import { makeStyles } from '@material-ui/styles';

/** Matches ecommerce tables (e.g. ParticipantsTable): blue header, row height, hover */
export const useTimesheetTableStyles = makeStyles({
  tablePaper: {
    borderRadius: 15,
    boxShadow: 'none',
    border: 'none',
    width: '100%',
    maxWidth: '100%',
    maxHeight: 'calc(100vh - 320px)',
    overflow: 'auto',
  },
  table: {
    '&.MuiTable-root': {
      width: 'max-content',
      minWidth: '100%',
    },
    '& .MuiTableCell-head': {
      color: 'black',
      backgroundColor: '#EAEEFF',
      fontSize: 16,
      fontWeight: 600,
      fontFamily: 'Raleway, sans-serif',
      height: 73,
      textAlign: 'center',
      position: 'sticky',
      top: 0,
      zIndex: 1,
    },
    '& .MuiTableCell-body': {
      color: 'black',
      fontSize: 14,
      fontWeight: 400,
      fontFamily: 'Raleway, sans-serif',
      height: 73,
      textAlign: 'center',
      borderBottom: 'none',
    },
    '& .MuiTableRow-root:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  scrollHint: {
    textAlign: 'center',
    padding: '12px 8px',
    color: '#757575',
    fontSize: 13,
  },
});
